const showFaceWorksMobil = () => {

	let faceWorksMobil = document.querySelector('.container .works .face-works-mobil'),
		faceWorks = document.querySelectorAll('.container .works .face-works');		

	if (faceWorksMobil) {
		
		faceWorksMobil.classList.remove('hide');				
		faceWorks[0].classList.add('hide');

	}	
}
export default showFaceWorksMobil;